// extracted by mini-css-extract-plugin
module.exports = {"PA_TrendChart":"TrendChart_PA_TrendChart__3T8FJ"};